/* RESPONSIBLE TEAM: team-data-foundations */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

let UsersLoadingRoute = GlobalLoadingRoute.extend({});

export default UsersLoadingRoute;
